import React, { useEffect } from "react";
import { connect } from "react-redux";
import { sha256 } from "js-sha256";
// import PropTypes from "prop-types";
import { withRouter, Link } from "react-router-dom";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Container,
  Input,
} from "reactstrap";
import ReactStickyHeadroom from "@integreat-app/react-sticky-headroom";
import { withTranslation } from "react-i18next";
// import getSymbolFromCurrency from "currency-symbol-map";
import {
  logoutUser,
  resetApp,
  resetLogout,
} from "../../redux/actions/authActions";
import {
  showWalletBalance,
  setSelectedCurrency,
} from "../../redux/actions/showWalletBalanceAction";
import dashboardRoutes from "../../routes/dashboard.jsx";
import ChangePassword from "../../components/Header/ChangePassword";
// import MerchantAPI from "./MerchantAPI.jsx";
import Notification from "../../components/Header/Notification";
import val from "../../getThemeDetails";
import CL from "../../components/Header/CL";
import Home from "../../components/Header/Home";

import Cart from "../../views/Carts/Cart";
//import QRCode from "./QRCode";
import { getCartList } from "../../redux/actions/marketPlaceAction";
import BackDrop from "../../components/BackDrop/BackDrop";
import { swalWithBootstrapButtons } from "../../utils/sweetalert";
import constants from "../../config/constants";
import { Grid } from "@mui/material";
import {
  getDashboardDetails,
  resetDashboardDetails,
  getDashboardFeeDetails,
  resetDashboardFeeDetails,
} from "../../redux/actions/showDashboardDetailsAction";
// import {
//   getKycDocList,
//   getCurrencyLoadLimit,
// } from "../../redux/actions/upgradeWalletAction";
// import { getMarketPlaceCategories } from "../../redux/actions/marketPlaceAction.js";
import { resetRegSecKey } from "../../redux/actions/regenerateSecKeyAction";
// import {
//   getWalletRoles,
//   getWalletSettings,
// } from "../../redux/actions/authActions";
// import { pendingRequestCount } from "../../redux/actions/pendingRequestCountAction";
// import { getProfileDetails } from "../../redux/actions/profileAction";
import { Typography } from "@mui/material";
import { getRegenerateToken, resetRegenerateToken } from "../../redux/actions/regenerateTokenAction";
import paymentzLogo from "../../assets/img/paymentz-icon.png";
import ThemeSwitcher from "../../components/DarkTheme/ThemeSwitcher.jsx";
import logoLight from "../../assets/img/sidebar/default_icon.png";
import logoDark from "../../assets/img/sidebar/default_iconDark.png";
import logoUnipayLight from "../../assets/img/sidebar/unipay_icon.png";
import logoUnipayDark from "../../assets/img/sidebar/unipay_iconDark.png";


//const val = themeDetails;
var plogo = "";
if (val.theme === "default") {
  plogo = require("../../assets/img/sidebar/" + val.theme + "_icon.png");
}
if (val.theme === "absa") {
  plogo = require("../../assets/img/sidebar/" + val.theme + "_icon_transparent.png");

}
else if (val.theme === "appletree") {
  plogo = require("../../assets/img/sidebar/" + val.theme + "_icon_transparent1.png");

}
else if (val.theme === "dreamzwallet") {
  plogo = require("../../assets/img/sidebar/" + val.theme + "_icon_transparent7.png");

}
else if (val.theme === "onetap") {
  plogo = require("../../assets/img/sidebar/" + val.theme + ".png");

}
else if (val.theme === "unipay") {
  plogo = require("../../assets/img/sidebar/" + val.theme + "_icon.png");

}
else if (val.theme === "aunipay") {
  plogo = require("../../assets/img/sidebar/" + val.theme + ".png");

}
else {
  plogo = require("../../assets/img/sidebar/" + val.theme + "_icon.png");

}
const logo = require("../../assets/img/sidebar/" + val.theme + ".png");

class MainHeader extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      dropdownOpen: false,
      color: "transparent",
      cPasswordModalOpen: false,
      counter: 0,
      converterModalOpen: false,
    };

    [
      "toggle",
      "openSidebar",
      "dropdownToggle",
      "handleChangePassword",
      "handleLogout",
      "profileRouteHandler",
      "upgradeWalletHandler",
      "currencyConverterHandler",
      "handleWalletAmountRefresh",
      "handleChangeCurrency",
      "handleCustomerSupport",
      "handleMerchantApi",
      "regenerateToken",
    ].forEach((v) => {
      this[v] = this[v].bind(this);
    });
  }

  toggle() {
    if (this.state.isOpen) {
      this.setState({
        color: "transparent",
      });
    } else {
      this.setState({
        color: "dark",
      });
    }
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  dropdownToggle(e) {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  }

  getBrand() {
    var name;
    dashboardRoutes.map((prop, key) => {
      if (prop.collapse) {
        prop.views.map((prop, key) => {
          if (prop.path === this.props.location.pathname) {
            name = prop.name;
          }
          return null;
        });
      } else {
        if (prop.redirect) {
          if (prop.path === this.props.location.pathname) {
            name = prop.name;
          }
        } else {
          if (prop.path === this.props.location.pathname) {
            name = prop.name;
          }
        }
      }
      return null;
    });

    return this.props.t(name);
  }
  openSidebar() {
    document.documentElement.classList.toggle("nav-open");
    this.refs.sidebarToggle.classList.toggle("toggled");
  }
  // function that adds color dark/transparent to the navbar on resize (this is for the collapse)
  updateColor() {
    if (window.innerWidth < 993 && this.state.isOpen) {
      this.setState({
        color: "dark",
      });
    } else {
      this.setState({
        color: "transparent",
      });
    }
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateColor.bind(this));
    this.getDetails();
    this.props.resetRegenerateToken()
    // Store ref so it can be cleared
    this.tokenInterval = setInterval(() => {
      if (!this.isRegenerating) {           // guard against overlap
        this.isRegenerating = true;
        this.regenerateToken().finally(() => {
          this.isRegenerating = false;  // reset after done
        });
      }
    }, 14 * 60 * 1000);

    this.regenerateToken(); // initial call on mount is fine
    //this.props.getCartList(this.getReq("cart"));
    //this.props.showWalletBalance(this.getReq());
  }


  // ✅ ADD THIS — was completely missing
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateColor.bind(this));
    if (this.tokenInterval) {
      clearInterval(this.tokenInterval);
      this.tokenInterval = null;
    }
  }

  regenerateToken() {
    // console.log("<<Main header")
    const regenerateTokenReq = {
      authentication: {
        partnerId: this.props.login.data.partnerId,
      },
      authToken: this.props.login.data.AuthToken,
    };

    return this.props.getRegenerateToken(regenerateTokenReq);
  }

  async getDetails() {
    await Promise.all([
      // this.props.getKycDocList(this.getRequests("Doc")), //getKycDocumentList
      // this.props.getCurrencyLoadLimit(this.getRequests("Limit")), //getCurrencyLoadLimit
      //this.props.getDashboardDetails(this.getReq("Dashboard")), //dashboard
      // this.props.getProfileDetails(this.getRequests("profile")), // dashboard box fee paid/received
      // this.props.showWalletBalance(this.getRequests("balance")),
      // this.props.getMarketPlaceCategories(this.getRequests("productCategory")),
      // this.props.getWalletSettings(this.getRequests("walletSettings")), // amountShow
      // this.props.pendingRequestCount(this.getRequests("pendingListCount")),
      // this.props.getWalletRoles(this.getRequests("role")),
    ])
      .then(() => {
        this.setState({ isBackdropVisible: false });
      })
      .catch((reject) => console.log(reject, "Oops something went wrong"));
  }

  getRequests = (type) => {
    if (type === "role") {
      return {
        walletOwnerId: val.walletOwnerId,
        token: val.token,
      };
    }
    const {
      login: {
        data: {
          secKey,
          customerId,
          entityType,
          accountType,
          cust_currency,
          dealerId,
          dsrId,
        },
      },
      showWalletBalanceState: { selectedCurrency },
    } = this.props;
    const { fDate, tDate } = this.state;
    const hash = sha256(
      secKey + customerId + `${type !== "balance" ? val.walletOwnerId : ""}`
    );

    // const veriHash = sha256(secKey + customerId);

    if (type === "walletSettings") {
      return {
        customerId,
        //currencyCode: cust_currency,
        currencyCode: "6",
        verificationHash: hash,
        walletOwnerId: val.walletOwnerId,
      };
    }

    // if (type === "pendingListCount") {
    //   return {
    //     customerId,
    //     verificationHash: veriHash,
    //     walletOwnerId: val.walletOwnerId,
    //   };
    // }

    if (type === "Dashboard") {
      return {
        customerId,
        wallet_owner_id: val.walletOwnerId,
        fromWalletCurrency: selectedCurrency,
        verificationHash: hash,
        dealerId,
        dsrId,
        initiatedBy: accountType,
        fromDate: fDate,
        toDate: tDate,
      };
    } else if (type === "balance" || type === "DbFee") {
      const ownerId =
        type === "Dashboard" || type === "DbFee"
          ? "wallet_owner_id"
          : "walletOwnerId";
      return {
        customerId,
        [ownerId]: val.walletOwnerId,
        fromWalletCurrency: selectedCurrency,
        verificationHash: hash,
      };
    } else if (type === "Doc") {
      return {
        customerId,
        walletOwnerId: val.walletOwnerId,
        kycAccount: accountType,
        user_type: entityType,
        verificationHash: hash,
      };
    } else {
      return {
        customerId,
        walletOwnerId: val.walletOwnerId,
        verificationHash: hash,
      };
    }
  };

  componentDidUpdate(e) {
    // console.log("prevProps", e);
    const {
      showWalletBalanceState,
      buyProductState,
      getCartList,
      resetLogout,
      logout,
      regenerateSecKeyState,
      authToken,
      t,
    } = this.props;
    if (
      window.innerWidth < 993 &&
      e.history.location.pathname !== e.location.pathname &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
      this.refs.sidebarToggle.classList.toggle("toggled");
    }

    // if (
    //   e.showWalletBalanceState.selectedCurrency !==
    //     showWalletBalanceState.selectedCurrency ||
    //   e.buyProductState.success !== buyProductState.success
    // ) {
    //   getCartList(this.getReq("cart"));
    // }

    if (e.logout.failed !== logout.failed) {
      sessionStorage.removeItem("authToken")
      window.location.href = "/index/login"
      resetLogout()
      // swalWithBootstrapButtons.fire({
      //   type: "error",
      //   title: "Oops!!",
      //   text: t(logout.status),
      //   onClose: () => {
      //     // history.push({
      //     //   pathname: "/index/login",
      //     // });
      //     sessionStorage.removeItem("authToken")
      //     window.location.href = "/index/login"
      //     resetLogout();
      //   },
      // });
    }


    if (
      regenerateSecKeyState.success !== e.regenerateSecKeyState.success &&
      logout.invalidRequest !== e.logout.invalidRequest
    ) {
      this.props.logoutUser(this.getReq("logout"), this.props.history);
    }
  }


  handleLogout() {
    document.body.classList.remove("lightThemeBackgroundDW");
    document.body.classList.remove("lightThemeBackground");
    sessionStorage.removeItem("persist:root");
    sessionStorage.removeItem("secKey");
    this.props.logoutUser(this.getReq("logout"), this.props.history);
  }

  // componentWillUnmount() {
  //   this.props.logoutUser(this.getReq("logout"), this.props.history);
  // }

  profileRouteHandler() {
    this.setState({ dropdownOpen: false });
    // this.props.history.push("/index/profile");
    this.props.history.push("/index/customer-master");
  }

  // loyaltyPointsHandler() {
  //   this.setState({ dropdownOpen: false });
  //   this.props.history.push("/index/loyalty-points");
  // }

  upgradeWalletHandler() {
    this.setState({ dropdownOpen: false });
    this.props.history.push("/index/upgrade-wallet");
  }

  handleCustomerSupport() {
    this.setState({ dropdownOpen: false });
    this.props.history.push("/index/customer-support");
  }

  handleMerchantApi() {
    this.setState({ dropdownOpen: false });
    this.props.history.push("/index/merchant-api");
  }

  handleChangePassword() {
    this.setState((state) => ({
      cPasswordModalOpen: !state.cPasswordModalOpen,
      counter: state.counter + 1,
      dropdownOpen: false,
    }));
  }

  currencyConverterHandler() {
    this.setState({ dropdownOpen: false });
    this.props.history.push("/index/currency-converter");
  }

  getReq(type) {
    const { secKey, customerId } = this.props.login.data;
    const verificationHash =
      type !== "logout"
        ? sha256(secKey + customerId)
        : sha256(secKey + customerId + "3");

    const commonReq = {
      customerId,
      verificationHash,
    };

    if (type === "logout") {
      return {
        // ...commonReq,
        // platformId: "3",
        // cust_device_id: "",
        authToken: this.props.login.data.AuthToken,
        authentication: {
          partnerId: this.props.login.data.partnerId,
        },
      };
    }

    // if (type === "cart") {
    //   const { selectedCurrency } = this.props.showWalletBalanceState;
    //   return {
    //     ...commonReq,
    //     currency: selectedCurrency,
    //     walletOwnerId: val.walletOwnerId,
    //   };
    // }

    return {
      ...commonReq,
      walletOwnerId: val.walletOwnerId,
    };
  }

  handleWalletAmountRefresh() {
    // this.props.showWalletBalance(this.getReq("refresh"));
  }

  handleChangeCurrency({ target: { value } }) {
    this.props.setSelectedCurrency(value);
  }

  render() {
    const {
      t,
      showWalletBalanceState,
      login,
      cartList,
      logout,
      walletSetting,
    } = this.props;
    !this.props.login.data && this.props.history.replace("/login");


    const logoMap = {
      default: {
        light: logoLight,
        dark: logoDark
      },
      unipay: {
        light: logoUnipayLight,
        dark: logoUnipayDark
      },

    };
    const theme = this.props.theme || val.theme;
    const isDark = theme.includes("Dark");
    const brand = theme.replace("Dark", "");
    const plogo =
      logoMap[brand] && logoMap[brand][isDark ? "dark" : "light"];
    // console.log("loginName", login);

    return (
      // add or remove classes depending if we are on full-screen-maps page or not
      <React.Fragment>
        <BackDrop isBackdropVisible={logout.isLoading} />
        <BackDrop isBackdropVisible={this.props.getMappedListRes.isLoading} />
        <ReactStickyHeadroom>
          <Navbar
            color={
              this.props.location.pathname.indexOf("full-screen-maps") !== -1
                ? "dark"
                : this.state.color
            }
            expand="lg"
            className={
              this.props.location.pathname.indexOf("full-screen-maps") !== -1
                ? "navbar-absolute fixed-top"
                : "navbar-absolute fixed-top " +
                (this.state.color === "transparent"
                  ? "navbar-transparent "
                  : "")
            }
          >
            <Container fluid>
              <div className="navbar-wrapper">
                {/* <div className="navbar-toggle">
                  <button
                    type="button"
                    ref="sidebarToggle"
                    className="navbar-toggler"
                    onClick={this.openSidebar}
                  >
                    <span className="navbar-toggler-bar bar1" />
                    <span className="navbar-toggler-bar bar2" />
                    <span className="navbar-toggler-bar bar3" />
                  </button>
                </div> */}
                {/* {abc && ( */}

                <Grid container>
                  {plogo && (
                    <Link
                      to={{
                        pathname: "/",
                        search: `?walletOwnerId=${val.walletOwnerId}`,
                      }}
                    >
                      {/* <img
                        src={plogo}
                        style={{
                          height: "87%",
                          width: "50px",
                          paddingRight: "5px",
                        }}
                        alt="react-p-logo"
                      /> */}
                      {this.props.location.pathname == "/index/homepage" && (
                        <img
                          src={
                            this.props.login.data.LoginName == "paymentz"
                              ? paymentzLogo
                              : plogo
                          }
                          // src={this.props.theme.includes("Dark") ? logoDark : logoLight}
                          // src={plogo}
                          height="50px"
                          className="mainLogo"
                          id="MainImg"
                          width="200px"
                          alt="Image"
                        // style={{filter:"invert(1)"}}
                        />
                      )}

                    </Link>

                  )}
                </Grid>

                {/* )} */}
                {/* <Grid container>
                  {plogo && (
                      <Link
                        to={{
                          pathname: "/",
                          search: `?walletOwnerId=${val.walletOwnerId}`,
                        }}
                      >
                        <img
                          src={plogo}
                          style={{
                             height: "87%",
                             width: "50px",
                             paddingRight: "5px"
                          }}
                          alt="react-p-logo"
                        />
                      </Link>
                  )}
                    <Link
                      to={{
                        pathname: "/",
                        search: `?walletOwnerId=${val.walletOwnerId}`,
                      }}
                    >
                      <img
                        src={logo}
                        alt="react-logo"
                        style={{
                          height: "80%",
                          width: "160px",
                        }}
                      />
                    </Link>
                </Grid> */}

                {/* <NavbarBrand className="hideForSmall" >
                  {this.getBrand()}
                </NavbarBrand> */}
              </div>

              {/* <div> */}
              {/* <div
                style={{ margin: "0 auto", zIndex: 9999 }}
                className="forBigScreenHide"
              >
                <span className="wallet-bal">
                  <Input
                    type="select"
                    className="db-wal-bal"
                    onChange={this.handleChangeCurrency}
                  >
                    {showWalletBalanceState.data.walletBalanceList &&
                    showWalletBalanceState.data.walletBalanceList.length ? (
                      showWalletBalanceState.data.walletBalanceList.map(
                        (opt) => (
                          <option
                            key={opt.currency}
                            value={opt.currency}
                            selected={
                              showWalletBalanceState.selectedCurrency
                                ? showWalletBalanceState.selectedCurrency ===
                                  opt.currency
                                : opt.isDefault === "Y"
                            }
                            defaultValue={
                              showWalletBalanceState.selectedCurrency
                                ? showWalletBalanceState.selectedCurrency ===
                                  opt.currency
                                : opt.isDefault === "Y"
                            }
                            // defaultValue={opt.isDefault === 'Y'}
                            // selected={
                            //   showWalletBalanceState.selectedCurrency
                            //     ? showWalletBalanceState.selectedCurrency ===
                            //       opt.currency
                            //     : opt.isDefault === "Y"
                            // }
                          >
                            {getSymbolFromCurrency(opt.currency) +
                              " " +
                              opt.balance}
                          </option>
                        )
                      )
                    ) : (
                      <option className="loading" />
                    )}
                  </Input>
                  <i
                    className={`fas fa-refresh ${
                      showWalletBalanceState.isLoading && "fa-spin"
                    } ml-2`}
                    onClick={this.handleWalletAmountRefresh}
                  />
                </span>
              </div> */}

              {/* <Cart cartList={cartList} /> */}
              <div className="showForSmall">
                <Home />
              </div>
              <div className="showForSmall">
                <CL />
              </div>

              {/* <div className="showForSmall">
                <Notification />
              </div>
              <div className="showForSmall">
                <QRCode />
              </div> */}

              <NavbarToggler onClick={this.toggle}>
                <span className="navbar-toggler-bar navbar-kebab" />
                <span className="navbar-toggler-bar navbar-kebab" />
                <span className="navbar-toggler-bar navbar-kebab" />
              </NavbarToggler>

              <Collapse
                style={{ position: "relative", flexGrow: "0" }}
                isOpen={this.state.isOpen}
                navbar
                className="justify-content-end"
              >
                <Nav navbar style={{ flexDirection: "row", alignItems: "center" }}>
                  {this.props.login.data.LoginName == "paymentz" ? (
                    ""
                  ) : (
                    <NavItem className="hideForSmall">
                      <CL />

                    </NavItem>


                  )}
                  {/* {this.props.login.data.LoginName == "paymentz" ? (
                    ""
                  ) : ( */}
                  <NavItem className="hideForSmall">

                    <Home />
                  </NavItem>
                  <NavItem className="hideForSmall">
                    <ThemeSwitcher />

                  </NavItem>


                  {/* )} */}

                  {/* <NavItem className="hideForSmall">
                    <Notification />
                  </NavItem> */}
                  {/* <NavItem className="hideForSmall">
                    <QRCode />
                  </NavItem> */}
                  <NavItem className="showForSmall">
                    <NavbarBrand>{this.getBrand()}</NavbarBrand>
                  </NavItem>
                  <Dropdown
                    nav
                    isOpen={this.state.dropdownOpen}
                    toggle={this.dropdownToggle}
                    style={{ flexGrow: 1, marginTop: "4px" }}
                  >
                    <DropdownToggle caret nav className="float-right">
                      {/* <p className="mx-1">M-Transact</p> */}
                      <Typography variant="subtitle2" className="mx-1">
                        {/* M-Transact */}
                        {login.data.Name}
                      </Typography>
                      <i
                        className="fa fa-user"
                        style={{ marginTop: "-20px!important" }}
                      />
                    </DropdownToggle>
                    <DropdownMenu right className="user-dropdown">
                      {/* {constants.visibleFlags.includes(
                        walletSetting.data.isProfileSetting
                      ) && (
                        <DropdownItem header>
                          <div onClick={this.profileRouteHandler}>
                            {t("Your Profile")}
                          </div>
                        </DropdownItem>
                      )} */}
                      {/* {login.data.accountType !== "DSR" &&
                        login.data.entityType === "Individual" && (
                          <DropdownItem header>
                            <div onClick={this.upgradeWalletHandler}>
                              {t("Upgrade Wallet")}
                            </div>
                          </DropdownItem>
                        )} */}

                      {/* {login.data.isLoyaltyPointsAllowed === "Y" && (
                        <DropdownItem header>
                          <div onClick={this.loyaltyPointsHandler}>
                            {t("Loyalty Points")}
                          </div>
                        </DropdownItem>
                      )} */}
                      <DropdownItem header className="change-password">
                        <div onClick={this.handleChangePassword}>
                          {t("Change Password")}
                        </div>
                      </DropdownItem>
                      {/* {constants.visibleFlags.includes(
                        walletSetting.data.apiKey
                      ) && (
                        <DropdownItem header className="merchant-api">
                          <div onClick={this.handleMerchantApi}>
                            {t("API KEY")}
                          </div>
                        </DropdownItem>
                      )} */}
                      {/* <DropdownItem divider /> */}
                      {/* <DropdownItem header className="customer-support">
                        <div onClick={this.handleCustomerSupport}>
                          {t("Help & Support")}
                        </div>
                      </DropdownItem> */}

                      <DropdownItem header className="logout">
                        <div onClick={this.handleLogout}>{t("Logout")}</div>
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>

                  <NavItem />
                </Nav>
              </Collapse>
            </Container>
          </Navbar>
        </ReactStickyHeadroom>
        {this.state.cPasswordModalOpen ? (
          <ChangePassword
            cPasswordModalOpen={this.state.cPasswordModalOpen}
            toggleModal={this.handleChangePassword}
            key={this.state.counter}
          />
        ) : (
          ""
        )}
      </React.Fragment>
    );
  }
}

// Header.propTypes = {
//   login: PropTypes.object.isRequired,
//   logOut: PropTypes.func.isRequired,
// };

const mapStateToProps = (state) => ({
  login: state.login || [],
  showWalletBalanceState: state.showWalletBalance,
  cartList: state.cartListDetail,
  buyProductState: state.buyProduct,
  logout: state.logout,
  walletSetting: state.walletSetting,
  regenerateSecKeyState: state.regenerateSecKey,
  regenerateTkn: state.regenerateToken,
  regenerateTokenRes: state.regenerateToken,
  getMappedListRes: state.getMappedList,
  getMappedListForAdminRes: state.getMappedListForAdmins,
  authToken: state.authToken,

  theme: state.theme.theme
});

export default withRouter(
  connect(mapStateToProps, {
    logoutUser,
    resetApp,
    showWalletBalance,
    setSelectedCurrency,
    getCartList,
    resetLogout,
    getDashboardDetails,
    // getCurrencyLoadLimit,
    // getKycDocList,
    showWalletBalance,
    resetDashboardDetails,
    resetRegSecKey,
    // getMarketPlaceCategories,
    getDashboardFeeDetails,
    resetDashboardFeeDetails,
    setSelectedCurrency,
    // getProfileDetails,
    // getWalletSettings,
    // pendingRequestCount,
    // getWalletRoles,
    getRegenerateToken,
    resetRegenerateToken
  })(withTranslation()(MainHeader))
);
